<div [class.load]="!isLoaded" class="message-editor">
  <div *ngIf="!isLoaded" class="loader-line-wrap">
    <div class="loader-line"></div>
    <div class="loader-line-text">ИИ работает...</div>
  </div>
  <div [class.has-variations]="hasVariations" *ngIf="allMessengersService.arTextVariations" class="NgxEditor__Wrapper">
    <button
      *ngIf="hasVariations && showImprove"
      (click)="contextMenuOpen({ event: $event, item: currentVariation })"
      class="text-pretty-gpt mr-2"
      nzShape="round" nz-button nzSize="small">
      Улучшить<span class="d-none d-md-inline"> текст</span>&nbsp;<i-feather name="cpu"></i-feather>
    </button>
    <ngx-editor-menu
      *ngIf="Service.message || interfaceService.isTelesellerDomain"
      [toolbar]="toolbar"
      [editor]="interfaceService.editor"
      [dropdownPlacement]="'top'"
    ></ngx-editor-menu>
    <ngx-editor
      (focusIn)="onFocus.emit()"
      (click)="setTextAreaPosition()"
      (keyup.enter)="textareaEnter($event)"
      [editor]="interfaceService.editor"
      [disabled]="false"
      [(ngModel)]="textMessage"
      [placeholder]="placeholderVariant"
    ></ngx-editor>
    <button *ngIf="interfaceService.isTelesellerDomain && Service._openChatId === 'sender'"
            (click)="modalService.openModal('BanAccountsComponent', {});"
            class="faq-text-info btn btn-warning stn-sm">Как написать?</button>
  </div>
  <ng-template [ngIf]="hasVariations">
    <div class="message-variations">

      <div *ngIf="isShowVariations; else showToggleButton" class="d-flex flex-wrap">
        <button *ngFor="let item of allMessengersService.arTextVariations; let i = index"
                [contextMenu]="contextMenu"
                [contextMenuSubject]="allMessengersService.arTextVariations[i]"
                (contextMenuOpen)="contextMenuOpen($event)"
                (click)="setTextMessage(i)" class="mr-2 mb-2 px-3 px-sm-4"
                nzShape="round" [nzGhost]="currentVariationIndex !== i" nz-button [nzType]="'primary'" nzSize="small">
          {{i + 1}}
        </button>
        <button
          *ngIf="isShowAddVariant"
          (click)="addVariation()" class="mr-2"
          nz-button nzType="link" nzSize="small">
          <i-feather name="plus"></i-feather>
        </button>
      </div>
      <ng-template #showToggleButton>
        <button
          id="add-variant-text"
          *ngIf="Service.message?.length > 50"
          (click)="showVariations()" class="mr-2"
          nzShape="round" nz-button nzType="primary" nzSize="small">
          Добавить варианты текста
        </button>
      </ng-template>


      <context-menu [contextMenu]="contextMenu">
        <ng-template [visible]="isText" (execute)="replaceTextFromPrompt($event.item.text, $event.item, offerPrompt)"
                     contextMenuItem let-item>
          Оптимизировать для рассылки&nbsp;<i-feather class="ml-auto float-right" name="battery-charging"></i-feather>
        </ng-template>
        <ng-template [visible]="isText" (execute)="rePhrase($event.item)" contextMenuItem let-item>
          Перефразировать&nbsp;<i-feather class="ml-auto float-right" name="edit"></i-feather>
        </ng-template>
        <ng-template [visible]="!isText" (execute)="rePhrase($event.item)" contextMenuItem let-item>
          Перефразировать из основного&nbsp;<i-feather class="ml-auto float-right" name="align-right"></i-feather>
        </ng-template>
        <ng-template [visible]="isText" (execute)="addSmile($event.item)" contextMenuItem let-item>
          Добавить смайлы&nbsp;<i-feather class="ml-auto float-right" name="smile"></i-feather>
        </ng-template>

        <ng-template [visible]="isText" (execute)="replaceTextFromPrompt($event.item.text, $event.item, addTextPrompt)"
                     contextMenuItem let-item>
          Дописать текст&nbsp;<i-feather class="ml-auto float-right" name="align-left"></i-feather>
        </ng-template>
        <ng-template [visible]="isText" (execute)="replaceTextFromPrompt($event.item.text, $event.item, cutTextPrompt)"
                     contextMenuItem let-item>
          Сократить текст&nbsp;<i-feather class="ml-auto float-right" name="align-left"></i-feather>
        </ng-template>
        <ng-template [visible]="isText" (execute)="replaceTextFromPrompt($event.item.text, $event.item, noSpamPrompt)"
                     contextMenuItem let-item>
          Добавить антиспам эффект&nbsp;<i-feather class="ml-auto float-right" name="user-check"></i-feather>
        </ng-template>
      </context-menu>
    </div>
  </ng-template>

</div>
